export const fr = {
	app_name: "Stocking",
	validate: "Valider",
	cancel: "Annuler",
	add: "Ajouter",
	edit: "Modifier",
	delete: "Supprimer",
	confirm: "Confirmation",
	close: "Fermer",
	yes: "Oui",
	no: "Non",
	loading: "Chargement",
	apply: "Appliquer",
	today: "Aujourd'hui",
	remove: "Supprimer",
	export: "Exporter",
	export_all: "Exporter tout",
	export_all_desc:
		"Exporter tous les matériels, y compris ceux non affichés dans la liste actuelle.",
	switch_light: "Passer en mode clair",
	switch_dark: "Passer en mode sombre",
	downloadUserGuide: "Guide utilisateur",
	logout: "Se déconnecter",
	created_info: "Créé le {date} par {user}",
	error: {
		field_required: "Le champ {0} est requis",
		login_not_found: "Erreur d'authentification",
		unknow_error: "Une erreur est survenue",
		range_required:
			"La plage de dates est requise : deux dates doivent être sélectionnées.",
		USER_DELETE_ERR_SELF: "Vous ne pouvez pas supprimer votre propre compte",
		USER_DELETE_ERR_LAST:
			"Il doit rester au moins un utilisateur administrateur actif",
		USER_MAIL_ALREADY_EXISTS:
			"Il existe déjà un utilisateur avec cette adresse mail.",
		USER_LOGIN_ALREADY_EXISTS:
			"Il existe déjà un utilisateur avec cet identifiant.",
		USER_NAME_ALREADY_EXISTS: "Il existe déjà un utilisateur avec ce nom.",
		USER_CANT_DOWNGRADE_ROLE:
			"Vous ne pouvez pas rétrograder votre propre rôle.",
		ARTICLE_LIBELLE_EXISTS: "Il existe déjà un matériel avec ce nom.",
		ARTICLE_DELETE_ERR_USED:
			"Ce matériel a des mouvements/affectations/packs qui le référencent et ne peut pas être supprimé.",
		FAMILLE_DELETE_ERR_USED:
			"Cette famille est utilisée par au moins un matériel et ne peut pas être supprimée.",
		FOURNISSEUR_DELETE_ERR_USED:
			"Au moins un matériel provient de ce fournisseur. Ce dernier ne peut pas être supprimé.",
		SITE_DELETE_ERR_USED:
			"Ce site est référencé par un autre site, une affectation, un inventaire ou un mouvement. Il ne peut pas être supprimé.",
		badpwd_previous: "Le mot de passe actuel est incorrect.",
		badpwd_empty: "Le nouveau mot de passe ne peut pas être vide.",
		reset_pwd_err_invalid:
			"Le nouveau mot de passe doit faire au moins 10 caractères, doit contenir au moins une lettre majuscule, une lettre minuscule, au moins un chiffre et un caractère spécial.",
		reset_pwd_err_confirm: "Les deux mots de passe ne correspondent pas.",
		reset_pwd_err_generic:
			"Une erreur est survenue lors de la réinitialisation du mot de passe. Veuillez réessayer.",
		reset_link_send_failed:
			"Une erreur est survenue lors de l'envoi de l'e-mail de réinitialisation du mot de passe. Veuillez réessayer.",
		stockcalendar_export_err:
			"Une erreur est survenue lors de l'exportation du calendrier des stocks. Veuillez réessayer.",
		duplicate_event_name: "Il existe déjà une affectation portant ce nom.",
		comment_too_long:
			"Le champ commentaire ne peut pas dépasser 800 caractères.",
		inventaire_quantite_nulle: "Toutes les quantités doivent être renseignées",
		no_articles:
			"Merci de sélectionner au moins un matériel avec une quantité positive",
	},
	search: {
		results: "Résultats de la recherche",
		here: "Rechercher ici",
		search: "Rechercher",
		filter: "Filtrer",
	},
	form: {
		nom: "Nom",
		email: "Adresse mail",
		tel: "Téléphone",
		pays: "Pays",
		ville: "Ville",
		code_postal: "Code postal",
		adresse_comp: "Adresse complément",
		adresse: "Adresse",
		login: "Identifiant",
		password: "Mot de passe",
		firstName: "Prénom",
		lastName: "Nom",
		role: "Rôle",
		enabled: "Actif",
		type: "Type",
		subType: "Sous type",
		commentaire: "Commentaire",
		ordre: "Ordre d'affichage",
		libelle: "Nom",
		quantite: "Quantité",
		quantite_virtuelle: "Quantité virtuelle",

		validator: {
			email: "Le format de l'adresse e-mail est invalide.",
		},
	},
	fournisseur: {
		empty: "Aucun fournisseur",
		list: "Liste des fournisseurs",
		add: "Ajout d'un fournisseur",
		update: "Modification d'un fournisseur",
		delete: "Etes-vous sur de vouloir supprimer ce fournisseur ?",
		created: "Fournisseur crée",
		updated: "Fournisseur modifié",
		deleted: "Fournisseur supprimé",
	},
	user: {
		empty: "Aucun utilisateur",
		list: "Liste des utilisateurs",
		add: "Ajout d'un utilisateur",
		update: "Modification d'un utilisateur",
		delete: "Etes-vous sur de vouloir supprimer cet utilisateur ?",
		created: "Utilisateur crée",
		updated: "Utilisateur modifié",
		deleted: "Utilisateur supprimé",
		enabled_success: "Utilisateur activé",
		disabled_success: "Utilisateur désactivé",
		enable: " Etes-vous sur de vouloir activer l'utilisateur ?",
		disable: "Etes-vous sur de vouloir désactiver l'utilisateur ?",
		change_pwd: "Changer le mot de passe",
		pwd_change: "Modification du mot de passe",
		old_pwd: "Mot de passe actuel",
		new_pwd: "Nouveau mot de passe",
		confirm_pwd: "Confirmer le nouveau mot de passe",
		pwd_change_success: "Le mot de passe a été modifié avec succès",

		role_admin: "Administrateur",
		role_user: "Utilisateur",

		disable_err_self: "Vous ne pouvez pas désactiver votre propre compte",
		disable_err_last:
			"Il doit rester au moins un utilisateur administrateur actif",

		forgot_password: "Mot de passe oublié",
		forgot_password_instructions:
			"Veuillez entrer votre adresse e-mail. Vous recevrez un e-mail avec des instructions pour réinitialiser votre mot de passe.",
		send_reset_link: "Envoyer le lien de réinitialisation",
		back_to_login: "Retour à la connexion",
		reset_link_sent:
			"Un e-mail avec les instructions de réinitialisation du mot de passe a été envoyé si l'adresse e-mail existe dans notre système.",
		reset_link_send_failed:
			"Échec de l'envoi de l'e-mail de réinitialisation du mot de passe. Veuillez réessayer plus tard.",
		pwd_change_instructions:
			"Veuillez entrer un nouveau mot de passe pour votre compte.",
	},
	site: {
		empty: "Aucun site",
		list: "Liste des sites",
		add: "Ajout d'un site",
		update: "Modification d'un site",
		delete: "Etes-vous sur de vouloir supprimer ce site ?",
		created: "Site crée",
		updated: "Site modifié",
		deleted: "Site supprimé",

		date_range: "Période d'ouverture",
		date_range_stockage: "Période d'ouverture (permanent)",

		stockage: "Stockage",
		exploitation: "Exploitation",

		nature_camp: "Nature camp",
		evenement: "Évènement",
		entrepot: "Entrepot",
		contenaire: "Contenaire",
		batiment: "Bâtiment",
		stockage_site: "Site de stockage",
		date_range_stockage_tooltip:
			"Un site de stockage est permanent et n'a pas de période d'ouverture.",
		stockage_linked_stockage_tooltip:
			"Seuls les sites d'exploitation sont liés à un site de stockage.",
	},
	famille: {
		empty: "Aucune famille",
		list: "Liste des familles",
		add: "Ajout d'une famille",
		update: "Modification d'une famille",
		delete: "Etes-vous sur de vouloir supprimer cette famille ?",
		created: "Famille créée",
		updated: "Famille modifiée",
		deleted: "Famille supprimée",
	},
	article: {
		empty: "Aucun matériel",
		list: "Liste des matériels",
		add: "Ajout d'un matériel",
		update: "Modification d'un matériel",
		delete: "Etes-vous sur de vouloir supprimer cet matériel ?",
		created: "Matériel crée",
		updated: "Matériel modifié",
		deleted: "Matériel supprimé",
		enabled_success: "Matériel activé",
		disabled_success: "Matériel désactivé",
		enable: "Etes-vous sur de vouloir activer le matériel ?",
		disable: "Etes-vous sur de vouloir désactiver le matériel ?",

		nom_restreint: "Description",
		famille: "Famille",
		fournisseur: "Fournisseur",
		proprietaire: "Propriétaire",
		code_emplacement: "Code emplacement",
		code_regroupement: "Code regroupement",
		categorie: "Catégorie",
		prix_moyen: "Prix moyen",
		seuil_global: "Seuil global",
		no_fournisseur: "Aucun fournisseur",
		valorisation_stock: "Valorisation du stock",
		valorisation_stock_tooltip:
			"Valeur totale du stock du matériel (quantité en stock sur tous les sites, multiplié par le prix moyen).",

		details: "Détails du matériel",
		stocks_by_site: "Stocks du matériel par site",
		stocks_at_date: "A la date du ",
		mouvements: "Mouvements du matériel",
		emplacement: "Emplacement",
		desactive_article_tooltip: "Matériel désactivé",
	},
	login: {
		login: "Identifiant",
		password: "Mot de passe",
		forgot_password: "Mot de passe oublié ?",
		sign_in: "Se connecter",
	},
	inventaire: {
		empty: "Aucun inventaire",
		list: "Liste des inventaires",
		create: "Nouvel inventaire",
		save: "Enregistrer",
		update: "Modification de l'inventaire",
		created: "Inventaire créé",
		updated: "Inventaire modifié",
		delete: "Etes-vous sur de vouloir supprimer cet inventaire ?",
		deleted: "Inventaire supprimé",
		add: "Ajout d'un inventaire",
		choix_site: "Choix du site",
		choix_site_info:
			"Sélectionner le site sur lequel vous souhaitez réaliser un inventaire.",
		quantite_en_stock: "Quantité en stock",
		quantite_theorique: "Quantité théorique",
		quantite_inventaire_precedent: "Qté inventaire précédent",
		quantite: "Quantité",
		filtre_famille: "Filtrer par famille",
		date: "Date",
		site: "Site",
		commentaire: "Commentaire",
		nb_articles: "Nombre de matériels",
		no_commentaire: "Aucun commentaire",
		details: "Détails de l'inventaire",
		nom_auteur: "Auteur",
		articles: "Matériels",
		confirm_finalize: "Confirmation de la validation de l'inventaire",
		confirm_finalize_desc:
			"Une fois l'inventaire validé, les quantités seront mises à jour et vous ne pourrez plus le modifier. Êtes-vous sûr de vouloir valider cet inventaire ?",
		status: "Statut",
		finalized: "Finalisé",
		in_progress: "En cours",
		aucun_resultat_recherche: "Aucun matériel trouvé",
		show_zero_qte_articles: "Afficher les matériels ayant une quantité zéro",
	},
	mouvement: {
		empty: "Aucun mouvement",
		create: "Nouveau mouvement",
		created: "Mouvement créé",
		add: "Ajout d'un mouvement",
		list: "Liste des mouvements",
		type: "Type de mouvement",
		aucun_article: "Aucun matériel",
		aucun_article_selectionne: "Aucun matériel sélectionné",
		date: "Date du mouvement",
		site: "Site",
		source: "Site source",
		destination: "Site destination",
		type_ajout: "+/- Manuel",
		type_rebus: "Mise au rebut",
		type_transfert: "Transfert",
		type_maj_inventaire: "Mise à jour inventaire",
		type_commande_en_cours: "Commande en cours",
		type_commande_receptionnee: "Commande réceptionnée",
		quantite_transfert: "Quantité à transférer",
		quantite_ajout: "Quantité à mouvementer",
		quantite_rebus: "Quantité à enlever",
		quantite_maj_inventaire: "Différence de quantité",
		quantite_source: "Quantité sur le site source",
		quantite_site: "Quantité sur le site",
		quantite_destination: "Quantité sur le site destination",
		quantite_commande_en_cours: "Quantité commandée",
		quantite_commande_receptionnee: "Quantité reçue",
		choix_site_info:
			"Sélectionner le type de mouvement ainsi que le(s) site(s) concerné(s).",
		recherche: "Rechercher un matériel...",
		article_count: "Nombre de matériels",
		no_mouvements: "Aucun mouvement",
		no_result_filter: "Aucun mouvement ne correspond aux filtres appliqués",
		details: "Détails du mouvement",
		quantite_details: "Quantité mouvementée",
		date_created: "Date de création",

		correct_errors: "Merci de corriger les erreurs avant de continuer",
		quantite_invalid:
			"La quantité de l'article {article} doit être supérieure à 0 et inférieure ou égale à {max}",
		error_inventaire_pending:
			"Un site sélectionné a un inventaire en cours. Veuillez le finaliser avant de continuer.",

		receptionner_commande: "Réceptionner la commande",
		reception_commande: "Réception de commande",
		date_reception: "Date de réception",
		quantite_commande: "Quantité commandée",
		quantite_recue: "Quantité reçue",
		create_order: "Créer une nouvelle commande et valider",
		create_order_desc:
			"Valider la réception partielle de la commande et créer une nouvelle commande à partir des articles manquants ? <br>Voici le contenu de la commande qui sera créée :",
		order_line_qte_less:
			"Vous avez indiqué avoir reçu une quantité inférieure à celle commandée.",

		order_update_create_success:
			"La commande a été validée avec succès et une nouvelle commande a été créée pour les articles manquants.",
		order_update_success: "La commande a été validée avec succès.",

		delete_confirm: "Êtes-vous sûr de vouloir supprimer ce mouvement ?",
		delete_success: "Mouvement supprimé avec succès.",
	},
	affectation: {
		list: "Liste des affectations",
		no_affectation: "Aucune affectation",
		no_result_filter: "Aucune affectation ne correspond aux filtres appliqués",
		date_installation: "Dates d'installation",
		date_evenement: "Dates",
		nom_evenement: "Nom",
		nom_auteur: "Auteur de l'affectation",
		site: "Site",
		articles: "Matériels",
		details: "Détails de l'affectation",
		update: "Modifier l'affectation",
		delete: "Etes-vous sur de vouloir supprimer cette affectation ?",
		created: "Affectation créée",
		updated: "Affectation modifiée",
		deleted: "Affectation supprimée",

		create: "Nouvelle affectation",
		site_stockage: "Site de stockage",
		site_exploitation: "Site d'exploitation",
		select_sites:
			"Veuillez sélectionner les sites de stockage et d'exploitation",
		aucun_article_selectionne: "Aucun matériel sélectionné",
		aucun_article_selectionne_error:
			"Au moins un matériel doit être sélectionné",
		selectionner_pack: "Sélectionner un pack",
	},
	calendar: {
		title: "Calendrier des stocks",
		date_range: "Plage de dates",
		sites: "Sites",
		familles: "Familles",
		condensed_view: "Vue condensée",
		virtual_stock_view: "Stock virtuel",
		virtual_stock_tooltip:
			"Affiche le stock virtuel en tenant compte des affectations entre les sites de stockage et d'exploitation.",
		condensed_view_tooltip:
			"Affiche le stock en regroupant les matériels par code de regroupement.",
		select_dates:
			"Veuillez sélectionner une plage de dates pour afficher les données.",
		no_data: "Aucune donnée correspondant aux critères sélectionnés.",
		min_stock: "Stock min",
		max_stock: "Stock max",
		affectation_range_description: "Dates d'installation : {0}",
	},
	affectation_calendar: {
		title: "Synthèse des affectations",
	},
	pack: {
		list: "Liste des packs",
		details: "Détails du pack",
		update: "Modification du pack",
		no_packs: "Aucun pack",
		create: "Nouveau pack",
		nom_pack: "Nom du pack",
		delete_confirm: "Etes-vous sur de vouloir supprimer ce pack ?",
		created: "Pack créé",
		updated: "Pack modifié",
		deleted: "Pack supprimé",
		recherche: "Rechercher un pack...",
		multiplier: "Multiplicateur",
	},
};
